import { gate } from 'hub-http/gates';
export const SECURITY_STATE_GATE = gate('abuse-mitigation:content-label-ui:use-security-state-point-fetch');